import React, { useEffect, useState } from 'react'
import styles from './Prefecture.module.css'
import { FormTitle } from '../../../Common/FormTitle'
import { NextButton } from '../../../Common/CtaButton/NextButton'
import { FormField } from '../../../Common/FormField'
import { validateZipCode } from './validate'
import { LeadText } from '../../../Common/LeadText'
import { useAbTestGtm } from '../../../../hooks/useAbTestGtm'

export const Prefecture = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const [zipCode, setZipCode] = useState('')
    const [address, setAddress] = useState('')
    const [cityId, setCityId] = useState<number | ''>('')
    const [cityAddressId, setCityAddressId] = useState<number | ''>('')
    const [prefectureId, setPrefectureId] = useState<number | ''>('')
    const [error, setError] = useState('')
    const [isFormValid, setIsFormValid] = useState(false)

    useEffect(() => {
        const validateAddress = async () => {
            const result = await validateZipCode(zipCode)

            setError(result.error)
            setIsFormValid(result.isValid)

            if (result.isValid && result.data) {
                setPrefectureId(result.data.prefectureId)
                setAddress(result.data.address)
                setCityId(result.data.cityId)
                setCityAddressId(result.data.cityAddressId)
            } else {
                setAddress('')
                setCityId('')
                setCityAddressId('')
            }
        }
        validateAddress()
    }, [zipCode])


    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText='今はどこに住んでいますか？'
                        dataViewLabel={dataViewLabel('EF_StepForm_住まい')}
                        dataClickLabel={dataClickLabel('EF_StepForm_住まい-戻る')}
                    />
                </div>
                <div className={styles.field}>
                    <FormField
                        label='郵便番号'
                        placeholder='1234567'
                        value={zipCode}
                        isInputType='text'
                        onChange={setZipCode}
                    />
                    <LeadText text='ハイフン「-」の入力は不要です' />
                </div>
                {isFormValid ? (
                    <div className={styles.addressResult}>
                        <img
                            src={'/foodslabo/addressPin.svg'}
                            alt={'住所ピン'}
                        />
                        <p>{address}</p>
                    </div>
                ) : (
                    <p style={{ color: 'red' }}>{error}</p>
                )}
                <NextButton
                    formKey={['prefecture', 'city', 'postalCode', 'cityAddressId']}
                    formValue={[prefectureId, cityId, zipCode, cityAddressId]}
                    displayFormKey={'prefectureCity'}
                    displayFormValue={address}
                    isDisabled={!isFormValid}
                    dataClickLabel={dataClickLabel('EF_StepForm_住まい-次へ')}
                />
            </div>
        </div>
    )
}
